/* Apex Theme - product gallery scroll-snap controller (AMZ)
   - Prevents thumbnail links from opening image URLs
   - Adds mobile dots
   - Enables swipe via native horizontal scrolling (touch)
   - Syncs active slide <-> active thumb <-> active dot
   - Responds to variant changes even if the theme's slider init fails
*/
(function () {
  var MQ_MOBILE = window.matchMedia('(max-width: 768px)');

  function qsa(root, sel) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function closest(el, sel) {
    while (el && el.nodeType === 1) {
      if (el.matches(sel)) return el;
      el = el.parentElement;
    }
    return null;
  }

  function getSlides(slider) {
    return qsa(slider, ':scope > .product-main-slide');
  }

  function getThumbs(productImagesRoot) {
    return qsa(productImagesRoot, '[data-product-thumb]');
  }

  function getActiveThumbIndex(thumbs) {
    for (var i = 0; i < thumbs.length; i++) {
      if (thumbs[i].classList.contains('is-active')) {
        var idx = parseInt(thumbs[i].getAttribute('data-index') || thumbs[i].dataset.index || '0', 10);
        if (!isNaN(idx)) return idx;
      }
    }
    return 0;
  }

  function buildDots(slider, count) {
    var dots = document.createElement('div');
    dots.className = 'amz-scroll-dots';
    var btns = [];
    for (var i = 0; i < count; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'amz-scroll-dot';
      b.setAttribute('aria-label', 'Go to image ' + (i + 1));
      dots.appendChild(b);
      btns.push(b);
    }
    slider.insertAdjacentElement('afterend', dots);
    return { el: dots, btns: btns };
  }

  function centerToSlide(slider, slide, smooth) {
    var left = slide.offsetLeft;
    try {
      slider.scrollTo({ left: left, behavior: smooth ? 'smooth' : 'auto' });
    } catch (e) {
      slider.scrollLeft = left;
    }
  }

  function nearestIndex(slider, slides) {
    var center = (slider.scrollLeft || 0) + (slider.clientWidth || 0) / 2;
    var best = 0;
    var bestDiff = Infinity;
    for (var i = 0; i < slides.length; i++) {
      var s = slides[i];
      var sCenter = (s.offsetLeft || 0) + (s.offsetWidth || 0) / 2;
      var diff = Math.abs(sCenter - center);
      if (diff < bestDiff) {
        bestDiff = diff;
        best = i;
      }
    }
    return best;
  }

  function setActive(state, index, doScroll) {
    if (!state || !state.slides.length) return;
    if (index < 0) index = 0;
    if (index > state.slides.length - 1) index = state.slides.length - 1;

    state.index = index;
    state.slides.forEach(function (slide, i) {
      slide.classList.toggle('is-selected', i === index);
      slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
    });

    state.thumbs.forEach(function (thumb, i) {
      thumb.classList.toggle('is-active', i === index);
    });

    if (state.dots && state.dots.btns) {
      state.dots.btns.forEach(function (btn, i) {
        btn.classList.toggle('is-active', i === index);
        btn.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    if (doScroll) {
      centerToSlide(state.slider, state.slides[index], true);
    }
  }

  function parseVariants(productSection) {
    var jsonEl = productSection.querySelector('[data-variant-json]');
    if (!jsonEl) return null;
    try {
      return JSON.parse(jsonEl.textContent || jsonEl.innerHTML || '[]');
    } catch (e) {
      return null;
    }
  }

  function findVariantById(variants, id) {
    if (!variants || !variants.length) return null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(id)) return variants[i];
    }
    return null;
  }

  function getVariantIdFromDOM(productSection) {
    // Shopify standard: hidden input[name="id"] holds the selected variant id
    var idInput = productSection.querySelector('input[name="id"]');
    if (idInput && idInput.value) return idInput.value;

    var select = productSection.querySelector('[data-product-select]');
    if (select && select.value) return select.value;
    // Fallback: try any checked variant input
    var checked = productSection.querySelector('[data-variant-input]:checked');
    if (checked && checked.value) return checked.value;
    return null;
  }

  function gotoVariantImage(state, variant) {
    if (!state || !variant) return;
    // Preferred: featured_media.id
    var mediaId = variant.featured_media && variant.featured_media.id;
    if (mediaId) {
      for (var i = 0; i < state.thumbs.length; i++) {
        var id = state.thumbs[i].getAttribute('data-id') || '';
        if (String(id) === String(mediaId)) {
          setActive(state, i, true);
          return;
        }
      }
    }

    // Fallback: featured_image.id (sometimes present instead of featured_media)
    var imageId = variant.featured_image && variant.featured_image.id;
    if (imageId) {
      for (var j = 0; j < state.thumbs.length; j++) {
        var tid = state.thumbs[j].getAttribute('data-id') || '';
        if (String(tid) === String(imageId)) {
          setActive(state, j, true);
          return;
        }
      }
    }

    // Fallback: featured_image.position (1-based)
    var pos = variant.featured_image && variant.featured_image.position;
    if (pos && !isNaN(pos)) {
      var idxPos = parseInt(pos, 10) - 1;
      if (idxPos >= 0 && idxPos < state.slides.length) {
        setActive(state, idxPos, true);
        return;
      }
    }
    // Fallback: featured_image src match
    var imgSrc = variant.featured_image && (variant.featured_image.src || variant.featured_image);
    if (imgSrc) {
      for (var s = 0; s < state.slides.length; s++) {
        var img = state.slides[s].querySelector('img');
        if (img && img.getAttribute('src') && img.getAttribute('src').indexOf(imgSrc.split('?')[0]) >= 0) {
          setActive(state, s, true);
          return;
        }
      }
    }
  }

  function initOne(productSection) {
    var productImagesRoot = productSection.querySelector('[data-product-images]');
    if (!productImagesRoot) return;

    var slider = productImagesRoot.querySelector('[data-product-photos].product-slideshow');
    if (!slider) return;
    if (slider.dataset.amzScrollReady === '1') return;

    var slides = getSlides(slider);
    if (slides.length <= 1) return;

    slider.dataset.amzScrollReady = '1';
    slider.classList.add('amz-scroll-slider');

    // Ensure data-index exists and slides are visible (some themes hide all but first by default)
    slides.forEach(function (slide, i) {
      if (!slide.hasAttribute('data-index')) slide.setAttribute('data-index', String(i));
      slide.style.display = 'block';
    });

    var thumbs = getThumbs(productImagesRoot);
    var dots = buildDots(slider, slides.length);

    var state = {
      productSection: productSection,
      slider: slider,
      slides: slides,
      thumbs: thumbs,
      dots: dots,
      index: 0,
      isProgrammatic: false
    };
    slider.__amzScrollState = state;

    // Set initial index based on existing active thumb
    var startIndex = getActiveThumbIndex(thumbs);
    setActive(state, startIndex, false);
    centerToSlide(slider, slides[startIndex], false);

    // Thumb clicks
    thumbs.forEach(function (thumb) {
      if (thumb.__amzScrollBound) return;
      thumb.__amzScrollBound = true;
      thumb.addEventListener('click', function (e) {
        var idx = parseInt(thumb.getAttribute('data-index') || thumb.dataset.index || '0', 10);
        if (isNaN(idx)) return;
        // Always prevent navigating to the image URL
        e.preventDefault();
        setActive(state, idx, true);
      });
    });

    // Dot clicks
    dots.btns.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        setActive(state, i, true);
      });
    });

    // Sync on scroll (native swipe)
    var raf = null;
    slider.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var idx = nearestIndex(slider, slides);
        setActive(state, idx, false);
      });
    }, { passive: true });

    // Variant changes (listen for both custom event + DOM changes)
    var variants = parseVariants(productSection);

    productSection.addEventListener('variantImageChange', function (evt) {
      if (evt && evt.detail && evt.detail.variant) {
        gotoVariantImage(state, evt.detail.variant);
      }
    });

    productSection.addEventListener('variantChange', function () {
      var id = getVariantIdFromDOM(productSection);
      var v = findVariantById(variants, id);
      gotoVariantImage(state, v);
    });

    // Some code dispatches variant events on document
    document.addEventListener('variant:change', function (evt) {
      if (!evt || !evt.detail) return;
      // Only react if event is for our section
      if (evt.detail && evt.detail.sectionId) {
        var thisId = productSection.getAttribute('data-section-id') || productSection.dataset.sectionId;
        if (thisId && String(evt.detail.sectionId) !== String(thisId)) return;
      }
      if (evt.detail && evt.detail.variant) {
        gotoVariantImage(state, evt.detail.variant);
        return;
      }
      var id = getVariantIdFromDOM(productSection);
      var v = findVariantById(variants, id);
      gotoVariantImage(state, v);
    });

    // Also attach to select/input changes in case theme events are missing
    var variantSelect = productSection.querySelector('[data-product-select]');
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        // Allow theme scripts to update the hidden variant id input first
        setTimeout(function () {
          var id = getVariantIdFromDOM(productSection) || variantSelect.value;
          var v = findVariantById(variants, id);
          gotoVariantImage(state, v);
        }, 0);
      });
    }
    qsa(productSection, '[data-variant-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        setTimeout(function () {
          var id = getVariantIdFromDOM(productSection);
          var v = findVariantById(variants, id);
          gotoVariantImage(state, v);
        }, 0);
      });
    });
  }

  function initAll(root) {
    var scope = root || document;
    qsa(scope, '[data-apx-section="product"]')
      .forEach(initOne);
  }

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Shopify Theme Editor support
  document.addEventListener('shopify:section:load', function (evt) {
    initAll(evt.target);
  });
})();
